

















































































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import Multiselect from 'vue-multiselect';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'LocaleLanguage',
  components: {
    Multiselect,
    ProfilePlaceholder,
    AddEntity,
  },
})
export default class LocaleLanguage extends Mixins(GuidedSignupUtilities) {
  $wlToastr: any;
  private viewMode: boolean = true;
  private selectedLanguage: string = '';   
  private userSelectedLanguage: any = {}; 
  private languageArray: any[] = [];

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop() isRequiredStep;
  @Prop() minimumEntries;
  @Prop() isLastStep;

  editLanguage() {
    this.fetchUserSelectedLanguage(); 
    this.viewMode = false;
  }

  userPermissionConfig(permission: string) {
    return vxm.configs.getUserPermissionConfig(permission, 'LANGUAGE');
  }


  get supportedTranslationLanguages() {
    const langs = vxm.configs.getGlobalConfigValue('SUPPORTED_TRANSLATION_LANGUAGES');
    if (langs) return langs.split(',');
    return [];
  }

  fetchUserSelectedLanguage() {
    vxm.users.fetchLanguagePreference().then((languageCode: string) => {
      this.selectedLanguage = languageCode;
      this.userSelectedLanguage = this.getLanguageFromCode(languageCode);
    }).catch((error) => {
      console.error("Error fetching user language:", error);
    });
  }

  cancelChanges() {
    this.userSelectedLanguage = this.getLanguageFromCode(this.selectedLanguage);
    this.viewMode = true;
  }

  mounted() {
    this.languageArray = this.getLanguageArray;
    this.fetchUserSelectedLanguage(); 
    this.viewMode = this.isMyProfile;
  }

  updateChanges() {
    vxm.users.setUserLang(this.userSelectedLanguage.value.toString());
  }


  get isMyProfile() {
    if (this.$router.currentRoute.name === 'GuidedSignup') {
      this.viewMode = false;
      if (!this.userPermissionConfig('add')) {
        this.viewMode = true;
      }
      return this.viewMode;
    } else {
      return this.$router.currentRoute.name === 'LocaleLangauge';
    }
  }

  get getLanguageArray() {
    return this.supportedTranslationLanguages.map((language) => {
      return {
        label: this.$t(`lang.${language}`).toString(),
        value: vxm.utility.languageRegionMap[language],
      };
    });
  }

  getLanguageFromCode(languageCode: string) {
    return this.languageArray.find(language => language.value === languageCode) || {};
  }

  saveLanguage(language: string) {
    const response = vxm.users.setUserLang(language);
  }
}
